import { ReactNode } from "react";

const whyChooseItems = [
  "Random Second Withdraw Bonus — every second withdrawal brings a surprise reward, as low as $10 to join.",
  "New Register Free Credit Up To AUD 299 — sign up and claim free credits with no deposit required.",
  "Daily rebate up to 5% and weekly commissions up to 5% for all members — every player earns back automatically.",
];

const vipProgramItems = [
  "Deposit 30 AUD to earn a chance on the Fortune Wheel.",
  "Active players qualify for the VIP Program with extra VIP bonuses.",
  "Daily check-ins earn points for big prizes.",
  "VIP players complete daily missions to win the grand prize.",
];

function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-center gap-3 mb-8">
      <div className="w-1 h-6 rounded-full" style={{ background: "linear-gradient(180deg, #c9a84c, #6b21a8)" }}></div>
      <h2 className="section-title text-2xl md:text-3xl text-white/90">{children}</h2>
    </div>
  );
}

export { SectionLabel };

export default function WhatMakesSpecial() {
  return (
    <section id="what" className="max-w-5xl mx-auto px-6 py-12">
      <SectionLabel>What Makes Rolex9 Special</SectionLabel>

      {/* Why Choose Rolex9 */}
      <div className="mb-8">
        <h3
          className="text-white/80 font-bold text-lg md:text-xl text-center mb-6"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Why Choose Rolex9?
        </h3>
        <div className="space-y-4">
          {whyChooseItems.map((item, i) => (
            <div key={i} className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-vip-diamond-line text-[#c9a84c]/70 text-sm"></i>
              </div>
              <p className="text-white/50 text-sm leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Divider */}
      <div
        className="my-8"
        style={{ borderTop: "1px dashed rgba(201,168,76,0.25)" }}
      ></div>

      {/* VIP Program */}
      <div>
        <h3
          className="text-white/80 font-bold text-lg md:text-xl text-center mb-6"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          VIP Program
        </h3>
        <div className="space-y-4">
          {vipProgramItems.map((item, i) => (
            <div key={i} className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-vip-diamond-line text-[#c9a84c]/70 text-sm"></i>
              </div>
              <p className="text-white/50 text-sm leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}